module.exports = vendor_f0df7aff011777500a9f;